import { pxToRem } from './biomeTokens';
import { colorTheme } from './extendedColors';
import { radiiTheme } from './extendedRadii';
import { spacingTheme } from './extendedSpacing';

const primaryButton = {
  bg: colorTheme.accent[100],
  color: colorTheme.text['light'],
  fontSize: pxToRem(14),
  fontWeight: '500',
  lineHeight: pxToRem(16),
  borderRadius: pxToRem(3),
  h: pxToRem(40),
  pt: pxToRem(12),
  pr: pxToRem(16),
  pl: pxToRem(16),
  pb: pxToRem(12),

  _hover: {
    bg: colorTheme.accent[200]
  },
  _disabled: {
    bg: colorTheme.accent[50]
  },
  _active: { bg: colorTheme.accent[300] },
  _focus: {
    boxShadow: 'none'
  },
  _focusVisble: {
    outline: '2px solid rgba(66, 153, 225, 0.6) !important',
    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6) !important'
  }
};

const secondaryButton = {
  color: colorTheme.accent[100],
  border: `${pxToRem(1)} solid`,
  borderColor: colorTheme.accent[100],
  fontSize: pxToRem(14),
  fontWeight: '500',
  lineHeight: pxToRem(16),
  borderRadius: pxToRem(3),
  h: pxToRem(40),
  pt: pxToRem(12),
  pr: pxToRem(16),
  pl: pxToRem(16),
  pb: pxToRem(12),
  _hover: {
    bg: colorTheme.accent[50],
    color: colorTheme.accent[100],
    borderColor: colorTheme.accent[100]
  },
  _disabled: {
    color: colorTheme.accent[50],
    borderColor: colorTheme.accent[50]
  },
  _active: {
    bg: colorTheme.accent[50],
    color: colorTheme.accent[200],
    borderColor: colorTheme.accent[200]
  },
  _focus: {
    boxShadow: 'none'
  },
  _focusVisible: {
    outline: '2px solid rgba(66, 153, 225, 0.6) !important',
    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6) !important'
  }
};

const linksButton = {
  color: colorTheme.accent[100],
  borders: 'none',
  fontSize: pxToRem(14),
  fontWeight: '500',
  lineHeight: pxToRem(16),
  borderRadius: pxToRem(3),
  h: pxToRem(40),
  pt: pxToRem(12),
  pr: pxToRem(16),
  pl: pxToRem(16),
  pb: pxToRem(12),
  _hover: {
    bg: colorTheme.accent[50]
  },
  _disabled: {
    color: colorTheme.accent[50]
  },
  _active: {
    color: colorTheme.accent[200]
  },
  _focus: {
    boxShadow: 'none'
  }
};

const panelToggleButton = {
  bg: colorTheme.foundation[400],
  color: colorTheme.text['light'],
  fontSize: pxToRem(14),
  fontWeight: '500',
  lineHeight: pxToRem(16),
  borderRadius: pxToRem(100),
  h: pxToRem(24),
  w: pxToRem(24),
  minW: pxToRem(24),
  minH: pxToRem(24),
  pt: pxToRem(0),
  pr: pxToRem(0),
  pl: pxToRem(0),
  pb: pxToRem(0),
  _hover: {
    bg: colorTheme.accent[300]
  },
  _disabled: {
    bg: colorTheme.foundation[100]
  },
  _active: { bg: colorTheme.foundation[400] },
  _focus: {
    boxShadow: 'none'
  },
  _focusVisible: {
    outline: '2px solid rgba(66, 153, 225, 0.6) !important',
    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6) !important'
  }
};

const clockToggleButton = {
  bg: 'none',
  color: colorTheme.text['high emphasis'],
  fontSize: pxToRem(9.72),
  fontWeight: '400',
  lineHeight: pxToRem(16),
  borderRadius: 'none',
  h: '100%',
  w: '100%',
  minW: pxToRem(20),
  minH: pxToRem(20),
  pt: pxToRem(0),
  pr: pxToRem(4),
  pl: pxToRem(4),
  pb: pxToRem(0),
  gap: spacingTheme[4],
  _hover: {
    bg: colorTheme.accent[50]
  },
  _disabled: {
    bg: 'none'
  },
  _active: { bg: colorTheme.accent[50] },
  _focus: {
    boxShadow: 'outline'
  }
};

const clockToggleButtonv1 = {
  bg: colorTheme.chips.teal[50],
  color: colorTheme.text['high emphasis'],
  border: `${pxToRem(1)} solid`,
  borderColor: colorTheme.chips.teal[50],
  fontSize: pxToRem(9.72),
  fontWeight: '400',
  lineHeight: pxToRem(16),
  borderRadius: radiiTheme[3],
  h: spacingTheme[20],
  minW: pxToRem(20),
  minH: pxToRem(22),
  pt: pxToRem(1),
  pr: pxToRem(4),
  pl: pxToRem(4),
  pb: pxToRem(1),
  gap: spacingTheme[4],
  _hover: {
    bg: colorTheme.accent[50],
    borderColor: colorTheme.accent[50]
  },
  _disabled: {
    bg: 'none'
  },
  _active: { bg: colorTheme.accent[50] },
  _focus: {
    boxShadow: 'outline'
  }
};

export const buttonTheme = {
  variants: {
    primary: primaryButton,
    secondary: secondaryButton,
    links: linksButton,
    toggle: panelToggleButton,
    clock: clockToggleButton,
    clockv1: clockToggleButtonv1
  }
};
